import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";
import BrokerIcon from "../../Icons/BrokerIcon";
const BrokerListComponent = loadable(
  () => import("../../components/Broker/BrokerList")
);

const BrokerList = () => {
  return (
    <>
      <div>
        <div
          className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
        >
          <BrokerIcon />
          <span className={tw`text-[#5E5757] font-bold text-xl`}>Broker</span>
        </div>
      </div>
      <BrokerListComponent />
    </>
  );
};

export default BrokerList;
